import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4385 10.4384L14.4995 14.5M1.91714 8.78423C2.46032 10.0623 3.48897 11.0723 4.77679 11.5919C6.06462 12.1116 7.50614 12.0984 8.78423 11.5552C10.0623 11.0121 11.0723 9.98341 11.5919 8.69558C12.1116 7.40775 12.0984 5.96623 11.5552 4.68814C11.012 3.41005 9.9834 2.40009 8.69557 1.88042C7.40775 1.36076 5.96623 1.37397 4.68814 1.91714C3.41005 2.46032 2.40009 3.48897 1.88042 4.77679C1.36076 6.06462 1.37397 7.50614 1.91714 8.78423Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSearch;
